import { useCallback, useEffect, useState } from 'react';
import { parentApi } from '../services/parentApi';

export function useStudentCourseDetail(studentId, courseId) {
  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!studentId || !courseId) return;
    setLoading(true);
    setError(null);
    try {
      const data = await parentApi.getStudentCourse({ studentId, courseId });
      setCourse(data);
    } catch (e) {
      setError(e?.message || 'Failed to load course.');
    } finally {
      setLoading(false);
    }
  }, [studentId, courseId]);

  useEffect(() => {
    load();
  }, [load]);

  return { course, loading, error, reload: load };
}
